function HomeIco({ color }) {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.7 16.2405C3.20295 16.2405 2.8 15.8467 2.8 15.3608V9.50814C2.8 9.00555 3.01987 8.52697 3.40414 8.19312L9.40204 2.98168C9.74305 2.68539 10.2569 2.68539 10.598 2.98168L16.5958 8.19312C16.9801 8.52697 17.2 9.00555 17.2 9.50814V15.3608C17.2 15.8467 16.7971 16.2405 16.3 16.2405H3.7ZM1 15.3608C1 16.8184 2.20884 18 3.7 18H16.3C17.7912 18 19 16.8184 19 15.3608V9.50814C19 8.50296 18.5603 7.54581 17.7917 6.87809L11.7938 1.66666C10.7708 0.777779 9.22924 0.777779 8.20621 1.66666L2.20829 6.87809C1.43973 7.54581 1 8.50296 1 9.50814V15.3608Z"
        fill={color || "#D7E3E9"}
        stroke={color || "#D7E3E9"}
        stroke-width="0.2"
      />
    </svg>
  );
}

export default HomeIco;
